import React from 'react';
// Animated Loader 

// Default
import Lottie from "react-lottie";

// JSON
import SearchAnimation from "../../assets/lordIcons/wired-outline-1725-exit-sign-hover-pinch.json"

const LottieLoader = ({ width=30, height=30 }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: SearchAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Lottie options={defaultOptions} height={height} width={width} />
  )
}

export default LottieLoader

